import React from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import ConversationsView from "./ConversationsView";
import ConversationDetail from "./ConversationDetail";
import TurnDetail from "./TurnDetail";
import ActionDetail from "./ActionDetail";
import LLMRequestDetail from "./LLMRequestDetail";
import SettingsView from "./SettingsView";

export default function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-lg shadow flex flex-col">
      {/* Admin Header */}
      <div className="border-b border-gray-200 bg-gray-50 p-4 rounded-t-lg">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Admin Panel</h1>
          <div className="text-sm text-gray-600">
            Audit Data Explorer
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="mt-4 flex items-center space-x-4 border-b border-gray-200">
          <button
            onClick={() => navigate("/admin")}
            className={`pb-2 px-1 text-sm font-medium border-b-2 transition-colors ${
              location.pathname === "/admin" || location.pathname.includes("/conversation/")
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            Conversations
          </button>
          <button
            onClick={() => navigate("/admin/settings")}
            className={`pb-2 px-1 text-sm font-medium border-b-2 transition-colors ${
              location.pathname === "/admin/settings"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            Settings
          </button>
        </div>

        {/* Breadcrumb Navigation (for nested pages) */}
        {location.pathname !== "/admin" && location.pathname !== "/admin/settings" && (
          <div className="mt-2 flex items-center space-x-2 text-sm">
            <button
              onClick={() => navigate("/admin")}
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Conversations
            </button>
            <span className="text-gray-400">/</span>
            <span className="text-gray-700">
              {location.pathname.includes("/conversation/") && !location.pathname.includes("/turn/") ? "Conversation" : ""}
              {location.pathname.includes("/turn/") && !location.pathname.includes("/action/") ? "Turn" : ""}
              {location.pathname.includes("/action/") && !location.pathname.includes("/llm-request/") ? "Action" : ""}
              {location.pathname.includes("/llm-request/") ? "LLM Request" : ""}
            </span>
          </div>
        )}
      </div>

      {/* Admin Content */}
      <div className="p-4 min-h-0 flex-1 overflow-auto">
        <Routes>
          <Route index element={<ConversationsView />} />
          <Route path="settings" element={<SettingsView />} />
          <Route path="conversation/:conversationId" element={<ConversationDetail />} />
          <Route path="conversation/:conversationId/turn/:turnId" element={<TurnDetail />} />
          <Route path="conversation/:conversationId/turn/:turnId/action/:actionId" element={<ActionDetail />} />
          <Route path="conversation/:conversationId/turn/:turnId/action/:actionId/llm-request/:llmRequestId" element={<LLMRequestDetail />} />
        </Routes>
      </div>
    </div>
  );
}